import lazyLoad from "common/utils/lazyLoad";

// dynamically imported pillar component
export default lazyLoad(
  () => import(/* webpackChunkName: "OfflineSubscriptionImportPillar" */ "."),
);
